import { Slash } from "@insite/mobius/Breadcrumbs";
import getColor from "@insite/mobius/utilities/getColor";
import { chevronRightStringLight } from "@store/Library/Components/Icons/ChevronRight";
import { TYPOGRAPHY } from "@store/theme/common/design";
import { siteWidthStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

export default {
    defaultProps: {
        typographyProps: {
            color: "tertiary.light",
        },
        css: css`
            padding-bottom: 0;
            margin-top: 20px;
            flex-wrap: wrap;
            font-weight: ${TYPOGRAPHY.weight.bold};
            text-transform: uppercase;
            ${siteWidthStyles()}

            ${Slash} {
                margin: 0 3px 0 7px;
                font-size: 0;

                &::before {
                    content: "";
                    display: block;
                    width: 0.6em;
                    height: 0.6em;
                    font-size: ${TYPOGRAPHY.size.base};
                    background-image: url(${`data:image/svg+xml;base64,${chevronRightStringLight}`});
                    background-repeat: no-repeat;
                }
            }

            > a > span {
                color: ${getColor("secondary.main")} !important;

                &:hover {
                    color: ${getColor("secondary.dark")} !important;
                    text-decoration: underline;
                }
            }

            a:hover {
                color: ${getColor("secondary.dark")} !important;
            }

            > span:last-child {
                color: ${getColor("tertiary.light")};
                font-weight: ${TYPOGRAPHY.weight.bold};
            }
        `,
    },
};
